import { Chip, chipClasses, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

import { MessageVariant } from '../ChatUserMessage/ChatUserMessage.types';
import { useMessageSubmissionContext } from '../MessageSubmissionContextProvider/MessageSubmissionContextProvider.hook';

interface SuggestionProps {
  message: string;
}

const StyledChip = styled(Chip)(({ theme }) => ({
  [`&.${chipClasses.root}.${chipClasses.clickable}:hover`]: {
    backgroundColor: theme.palette.grey[400],
  },
}));

export const Suggestion = ({ message, children }: PropsWithChildren<SuggestionProps>) => {
  const { submitMessage } = useMessageSubmissionContext();
  return (
    <StyledChip
      variant="outlined"
      label={children}
      onClick={() => submitMessage({ text: message }, { type: MessageVariant.SUGGESTION })}
    />
  );
};
